import Vue from 'vue'
import Router from 'vue-router'
import landing from '@/pages/index'
import game from '@/pages/game'
import starship from '@/pages/starship/index'
import starshipId from '@/pages/starship/_id'
import elements from '@/pages/elements'
import ranking from '@/pages/ranking'
import profile from '@/pages/profile'

import login from '@/pages/login/index'
import loginGoogle from '@/pages/login/google'
import loginGoogleCallback from '@/pages/login/google-callback'

Vue.use(Router)

let loginRoutes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/login/google',
    name: 'login-google',
    component: loginGoogle
  },
  {
    path: '/login/google-callback',
    name: 'login-google-callback',
    component: loginGoogleCallback
  }
]

let routes = [
  {
    path: '/',
    name: 'landing',
    component: landing
  },
  {
    path: '/game',
    name: 'game',
    component: game,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/starship',
    name: 'starship',
    component: starship,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/starship/:id',
    name: 'starship_id',
    component: starshipId,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/elements',
    name: 'elements',
    component: elements,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: ranking,
    meta: {
      requiresAuth: true
    }
  },
  ...loginRoutes
]
let router = new Router({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js